const state = {
	user: {},
	wallet: 0,
	hasNewMessage: false,
	showChatBox: true
};

export default state;
